
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import mapper from './mappers/servicePointMapper';
import { publishAndAwait } from '../../../app/coreSlice';

const listServicePoints = async () => {

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'CARCLUB',
			subType: 'LIST_SERVICE_POINTS',
		},
	});
	
	const { processMessage, error } = request.response;
	
	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;


		throw new NGError({
			message: description,
			code,
			tag,
		});
	   };
	   
	return processMessage.map(mapper.fromDTO);
};

export default listServicePoints;
